import widgetModule from "@stoneage/Overrides/Components/AddressInfoDisplay";

export * from "@stoneage/Overrides/Components/AddressInfoDisplay";
export default widgetModule;
